<div class="expression-wrapper">
    <div class="input-container twc-mr-2">
        <label *ngIf="labelText" class="twc-tiny">{{labelText}}</label>
        <textarea twcTextarea [(ngModel)]="expression" [name]="fieldName" [ngClass]="{'twc-invalid':!isValid}"
            [placeholder]="placeholderText" [readonly]="!isEditable" (cwDebounceKeyUp)="onChange()" rows="1"></textarea>
    </div>
    <button class="twc-button twc-button-icon collage-button-raised" (click)="showExpressionEditor()"
        [disabled]="!isEditable" twcTooltip="{{'VECTOR_LAYER_PROPERTIES.EDIT_EXPRESSION' | translate}}">
        <twc-icon shape="draw" [size]="28"></twc-icon>
    </button>
</div>